import { combineActions, handleActions } from 'redux-actions';

import * as actionCreators from '../actions';
import { setupPhoneNumberSuccess } from 'modules/auth/components/MfaPanel/actions';

const defaultState = {};

export default handleActions(
  {
    [actionCreators.verificationPageOpened]() {
      return { ...defaultState };
    },
    [combineActions(
      actionCreators.getVerificationUserSuccess,
      actionCreators.updatePersonalDetailsSuccess,
      actionCreators.settingsVerificationUpdateSuccess,
      actionCreators.classicVerificationUpdateSuccess,
      actionCreators.classicVerificationSecondStepUpdateSuccess,
    )](state, action) {
      return { ...action.response.data };
    },
    [actionCreators.getVerificationUserSuccess]: (state, action) => {
      return { ...state, applicationLog: action.response.data };
    },
    [setupPhoneNumberSuccess]: (state, action) => {
      return {
        ...state,
        ...{
          profile: {
            ...(state.profile || {}),
            phoneCountry: action.payload.phoneCountry,
            phoneNumber: action.payload.phoneNumber,
            phoneVerified: false,
          },
        },
        ...{
          mfa: {
            ...(state.mfa || {}),
            phoneNumber: action.response.data.phoneNumber,
          },
        },
      };
    },
  },
  defaultState,
);
